const TOKEN_KEY = 'access_token'
const USER_ID_KEY = 'userId'
const CASHBOX_NUMBER = 'cashboxnumber'
const CASHBOX_ID = 'cashboxId'
const CASHBOX_IP_ADDRESS = 'cashboxIpAddress'
const IS_CASHIER = 'isCashier'
const IS_CONTRAGENT = 'isContragent'
const IS_MONITORING = 'isMonitoring'
const IS_MANAGER = 'isManager'
const IS_ADMIN = 'isAdmin'
const SESSION_START_TO_DEPARTMENT = 'session_to_dep'
const DEPARTMENT_ID = 'dep_id'
const DEPARTMENT_SALE_TYPE = 'dep_sale_type'
const USERNAME = 'userName'
const DEPARTMENT_TYPE = 'dep_type'
const DEP_CURRENCY_ID = 'depCurrencyId'
const DEP_CURRENCY_CODE = 'depCurrencyCode'
const DEP_CURRENCY_NAME = 'depCurrencyName'
const CONTRAGENT_ID = 'contragent_id'
const USER_ROLES = 'user_roles'
const LAST_CURRENT_PAGE = 'lastCurrentPage'
/*const CART_ITEM = 'cartItem';
const POS = 'pos';*/

const TokenService = {
	setLastCurrentPage(lastCurrentPage) {
		localStorage.setItem(LAST_CURRENT_PAGE, lastCurrentPage)
	},
	getLastCurrentPage() {
		return JSON.parse(localStorage.getItem(LAST_CURRENT_PAGE));
	},
	setContragentId(contragentId) {
		localStorage.setItem(CONTRAGENT_ID, contragentId)
	},
	getContrAgentId() {
		return localStorage.getItem(CONTRAGENT_ID);
	},
	removeContrAgentId() {
		localStorage.removeItem(CONTRAGENT_ID);
	},
	getToken() {
		return localStorage.getItem(TOKEN_KEY);
	},

	saveToken(token) {
		localStorage.setItem(TOKEN_KEY, token);
	},

	saveCurrentUserId(id) {
		localStorage.setItem(USER_ID_KEY, id);
	},
	getCurrentUserId() {
		return localStorage.getItem(USER_ID_KEY);
	},

	removeToken() {
		localStorage.removeItem(TOKEN_KEY);
	},

	removeCurrentUserId() {
		localStorage.removeItem(USER_ID_KEY);
	},
	removeCashboxNumber() {
		localStorage.removeItem(CASHBOX_NUMBER);
	},
	saveCashBoxNumber(cashboxNumber) {
		localStorage.setItem(CASHBOX_NUMBER, cashboxNumber);
	},
	removeCashboxId() {
		localStorage.removeItem(CASHBOX_ID);
	},
	saveCashBoxId(cashboxNumber) {
		localStorage.setItem(CASHBOX_ID, cashboxNumber);
	},
	removeCashboxIpAddress() {
		localStorage.removeItem(CASHBOX_IP_ADDRESS);
	},
	saveCashBoxIpAddress(cashboxIpAddress) {
		localStorage.setItem(CASHBOX_IP_ADDRESS, cashboxIpAddress);
	},
	getCashBoxNumber() {
		return localStorage.getItem(CASHBOX_NUMBER);
	},
	getCashBoxId() {
		return JSON.parse(localStorage.getItem(CASHBOX_ID));
	},
	getCashBoxIpAddress() {
		return localStorage.getItem(CASHBOX_IP_ADDRESS);
	},
	setIsCashier(boolean) {
		localStorage.setItem(IS_CASHIER, boolean);
	},
	setIsMonitoring(boolean) {
		localStorage.setItem(IS_MONITORING, boolean);
	},
	getIsCashier() {
		return localStorage.getItem(IS_CASHIER);
	},
	getIsMonitoring() {
		return localStorage.getItem(IS_MONITORING);
	},
	setIsManager(boolean) {
		localStorage.setItem(IS_MANAGER, boolean);
	},
	setIsAdmin(boolean) {
		localStorage.setItem(IS_ADMIN, boolean);
	},
	setIsContragent(boolean) {
		localStorage.setItem(IS_CONTRAGENT, boolean);
	},
	getIsManager() {
		return localStorage.getItem(IS_MANAGER);
	},
	getIsAdmin() {
		return localStorage.getItem(IS_ADMIN);
	},
	getIsContragent() {
		return localStorage.getItem(IS_CONTRAGENT);
	},
	removeIsContragent() {
		localStorage.removeItem(IS_CONTRAGENT);
	},
	removeIsCashier() {
		localStorage.removeItem(IS_CASHIER);
	},
	removeIsMonitoring() {
		localStorage.removeItem(IS_MONITORING);
	},
	removeIsManager() {
		localStorage.removeItem(IS_MANAGER);
	},
	removeIsAdmin() {
		localStorage.removeItem(IS_ADMIN);
	},
	saveUserRoles(roles) {
		localStorage.setItem(USER_ROLES, roles);
	},

	getUserRoles() {
		return localStorage.getItem(USER_ROLES);
	},

	removeUserRoles() {
		return localStorage.removeItem(USER_ROLES);
	},

	setDepSaleType(depSaleType) {
		localStorage.setItem(DEPARTMENT_SALE_TYPE, depSaleType);
	},

	/* DEP CURRENCY SAVE */
	saveDepCurrencyId(depCurrencyId) {
		localStorage.setItem(DEP_CURRENCY_ID, depCurrencyId);
	},
	saveDepCurrencyCode(depCurrencyCode) {
		localStorage.setItem(DEP_CURRENCY_CODE, depCurrencyCode);
	},
	saveDepCurrencyName(depCurrencyName) {
		localStorage.setItem(DEP_CURRENCY_NAME, depCurrencyName);
	},
	/* DEP CURRENCY GETTER */
	getDepCurrencyId() {
		return localStorage.getItem(DEP_CURRENCY_ID);
	},
	getDepCurrencyCode() {
		return localStorage.getItem(DEP_CURRENCY_CODE);
	},
	getDepCurrencyName() {
		return localStorage.getItem(DEP_CURRENCY_NAME);
	},
	getDepSaleType() {
		return localStorage.getItem(DEPARTMENT_SALE_TYPE);
	},
	/* DEP CURRENCY REMOVE */
	removeDepCurrencyId() {
		localStorage.removeItem(DEP_CURRENCY_ID);
	},
	removeDepCurrencyCode() {
		localStorage.removeItem(DEP_CURRENCY_CODE);
	},
	removeDepCurrencyName() {
		localStorage.removeItem(DEP_CURRENCY_NAME);
	},
	removeDepSaleType() {
		localStorage.removeItem(DEPARTMENT_SALE_TYPE);
	},

	sessionStartForDepartment(session) {
		localStorage.setItem(SESSION_START_TO_DEPARTMENT, session)
	},
	getCurrentSessionDepartment() {
		return localStorage.getItem(SESSION_START_TO_DEPARTMENT);
	},
	stopSessionToDepartment() {
		localStorage.removeItem(SESSION_START_TO_DEPARTMENT);
	},
	saveDepartmentId(id) {
		localStorage.setItem(DEPARTMENT_ID, id)
	},
	setUserName(userName) {
		localStorage.setItem(USERNAME, userName);
	},
	getUserName() {
		return localStorage.getItem(USERNAME);
	},
	getDepartmentId() {
		return localStorage.getItem(DEPARTMENT_ID)
	},
	removeDepartmentId() {
		localStorage.removeItem(DEPARTMENT_ID);
	},
	setDepartmentType(type) {
		localStorage.setItem(DEPARTMENT_TYPE, type);
	},
	getDepartmentType() {
		return localStorage.getItem(DEPARTMENT_TYPE)
	},

	/*setPos(posObj) {
		localStorage.setItem(POS, posObj);
	},
	getPos() {
		return localStorage.getItem(POS);
	},*/
};

export {TokenService}
